import { Plus, Trash2, Baby, User, Users } from "lucide-react";
import { useLang } from "../../lib/i18n";
import { SailorFields, ChipSelect, Field } from "../../components/site/ProfileFields";

export const WhoStep = ({ who, setWho }) => {
  const { t } = useLang();
  const opts = [["self", User, t("reg_who_self")], ["children", Users, t("reg_who_child")]];
  return (
    <div className="space-y-3" data-testid="register-who-step">
      <p className="font-semibold text-[#0A2540]">{t("reg_who_q")}</p>
      {opts.map(([v, Icon, label]) => (
        <button type="button" key={v} onClick={() => setWho(v)} data-testid={`register-who-${v}`}
          className={`flex w-full items-center gap-3 rounded-2xl border-2 p-4 text-left font-semibold transition-colors ${who === v ? "border-[#FF5722] bg-orange-50 text-[#0A2540]" : "border-slate-200 text-slate-600 hover:border-slate-300"}`}>
          <Icon size={20} className={who === v ? "text-[#FF5722]" : "text-slate-400"} />{label}
        </button>
      ))}
    </div>
  );
};

export const ChildrenStep = ({ kids, setKids }) => {
  const { t } = useLang();
  const set = (i, v) => setKids(kids.map((k, j) => (j === i ? v : k)));
  return (
    <div className="space-y-6" data-testid="register-children-step">
      {kids.map((k, i) => (
        <div key={i} className="space-y-4 rounded-2xl border border-slate-200 p-5" data-testid={`register-child-${i}`}>
          <div className="flex items-center justify-between">
            <p className="flex items-center gap-2 font-semibold text-[#0A2540]"><Baby size={18} className="text-[#00A8B5]" />{t("reg_child")} {i + 1}</p>
            {kids.length > 1 && <button type="button" onClick={() => setKids(kids.filter((_, j) => j !== i))} className="text-slate-400 hover:text-rose-500" data-testid={`register-child-remove-${i}`}><Trash2 size={16} /></button>}
          </div>
          <SailorFields f={k} setF={(v) => set(i, v)} prefix={`child-${i}-`} child />
          <Field label={t("classes_practiced")}><ChipSelect value={k.classes || []} onChange={(v) => set(i, { ...k, classes: v })} testid={`child-${i}-classes-chip`} /></Field>
        </div>
      ))}
      <button type="button" onClick={() => setKids([...kids, { classes: [] }])} className="flex items-center gap-2 text-sm font-semibold text-[#00A8B5]" data-testid="register-add-child"><Plus size={16} />{t("reg_add_child")}</button>
    </div>
  );
};
